import React from 'react';

interface HeadingProps {
  children: React.ReactNode;
  className?: string;
  as?: React.ElementType; // ✅ allows any valid tag or component
}

const Heading: React.FC<HeadingProps> = ({
  children,
  className = '',
  as: Tag = 'h2',
}) => {
  return (
    <Tag
      className={`text-xl md:text-[40px] font-bold text-primary mb-2 md:mb-4 ${className}`}
    >
      {children}
    </Tag>
  );
};

export default Heading;
